import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { OBSIDIAN } from 'HubStyleTokens/colors';
import styled from 'styled-components';
import UIImage from 'UIComponents/image/UIImage';
import UIFlex from 'UIComponents/layout/UIFlex';
import imageUrls from '../../images/imageUrls';
import { GuaranteeBannerContent } from './GuaranteeBannerContent';
import { GuaranteeBannerFeaturesLink } from './GuaranteeBannerFeaturesLink';
import { GuaranteeBannerHeader } from './GuaranteeBannerHeader';
const GuaranteeBannerWrapper = styled(UIFlex).withConfig({
  displayName: "GuaranteeBanner__GuaranteeBannerWrapper",
  componentId: "fc8ajp-0"
})(["background:", ";position:relative;"], OBSIDIAN);
const ArchSmall = styled(UIImage).withConfig({
  displayName: "GuaranteeBanner__ArchSmall",
  componentId: "fc8ajp-1"
})(["position:absolute;left:0;bottom:0;opacity:0.5;width:10%;height:auto;max-height:200px;max-width:200px;"]);
const ArchLarge = styled(UIImage).withConfig({
  displayName: "GuaranteeBanner__ArchLarge",
  componentId: "fc8ajp-2"
})(["position:absolute;right:0;bottom:0;opacity:0.5;width:85%;height:auto;max-height:190px;max-width:1800px;"]);
export const GuaranteeBanner = () => {
  return /*#__PURE__*/_jsxs(GuaranteeBannerWrapper, {
    align: "center",
    "data-selenium": 'guaranteeBanner',
    direction: 'column',
    id: 'guaranteeBanner',
    justify: "between",
    children: [/*#__PURE__*/_jsx(GuaranteeBannerHeader, {}), /*#__PURE__*/_jsx(GuaranteeBannerContent, {}), /*#__PURE__*/_jsx(GuaranteeBannerFeaturesLink, {}), /*#__PURE__*/_jsx(ArchSmall, {
      height: 200,
      responsive: false,
      src: imageUrls.archSmall
    }), /*#__PURE__*/_jsx(ArchLarge, {
      responsive: false,
      src: imageUrls.archLarge
    })]
  });
};